import { Affix, Button, Card, Form } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useNavigate } from "react-router-dom";
import AmendmentLienCostForm from "../AmendmentLienCostForm";

const AddAmendmentLienCost = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const discardForm = () => {
    navigate("/import-export-expense-tracking/amendment-lien-cost");
  };

  const addNewAmendmentLienCost = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Add New Amendment Lien Cost"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discardForm()}>
                Discard
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => addNewAmendmentLienCost()}
              >
                Add Amendment Lien Cost
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <AmendmentLienCostForm form={form} />
    </>
  );
};

export default AddAmendmentLienCost;
